var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice-wrapper"},[(_vm.iframeUrl)?_c('iframe',{staticClass:"invoice-iframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }